// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.core--table{height:100%;display:flex;flex-direction:column}`, "",{"version":3,"sources":["webpack://./src/common-client2/src/components/Table/Table.scss"],"names":[],"mappings":"AAAA,aACI,WAAA,CACA,YAAA,CACA,qBAAA","sourcesContent":[".core--table {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
